import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { EntityEffects } from '@signature-it/ngx-entity/store/effects';

@NgModule({
    imports: [
        EffectsModule.forFeature([EntityEffects])
    ],
})
export class EntityStoreModule {}
